function _watermarkShowTime(t) {
  var time;
  time = t >= 10 ? t : "0" + t;
  return time;
}

function _watermarkdateFormat(date) {
  var year = date.getFullYear(); // 年
  var month = _watermarkShowTime(date.getMonth() + 1); // 月
  var day = _watermarkShowTime(date.getDate()); // 日
  var hours = _watermarkShowTime(date.getHours()); // 小时
  var minutes = _watermarkShowTime(date.getMinutes()); // 分钟
  var second = _watermarkShowTime(date.getSeconds()); // 秒
  return `${year}-${month}-${day} ${hours}:${minutes}:${second}`;
}

function _watermarkCheck() {
  if (
    localStorage.getItem("name") &&
    localStorage.getItem("ip") &&
    localStorage.getItem("name") != window._watermarkname
  ) {
    document.getElementById("_watermark") &&
      document.getElementById("_watermark").remove();
    let name = localStorage.getItem("name");
    window._watermarkname = name;
    let ip = localStorage.getItem("ip");
    let date = _watermarkdateFormat(new Date());
    let div = document.createElement("div");
    div.className = "watermark";
    div.id = "_watermark";
    for (let _i of new Array(20)) {
      div.innerHTML += `<div class="watermark-item"><div>账号: ${
        _i || name
      }</div><div>IP: ${ip}</div><div>登录时间: ${date}</div></div>`;
    }
    div.innerHTML += `<style>
                        .watermark {
                            position: absolute;
                            top: 0;
                            right: 0;
                            bottom: 0;
                            left: 0;
                            width: 100vw;
                            height: 100vh;
                            opacity: 0.1;
                            overflow: hidden;
                            pointer-events: none;
                            display: flex;
                            flex-wrap: wrap;
                            z-index: 99999999;
                        }
                        .watermark-item {
                          min-width: 200px;
                          transform: rotate(20deg);
                          color: #ccc;
                          font-size: 14px;
                          padding: 150px;
                      }
    </style>`;
    document.body.appendChild(div);
    return;
  }
  window.setTimeout(_watermarkCheck, 500);
}

// window.setTimeout(_watermarkCheck, 500);

export default {
  _watermarkCheck
}

